import posthog from 'posthog-js';

const publicPaths = new Set(['/', '/pricing', '/how-it-works', '/use-cases', '/docs', '/docs/cli']);
let recordedUrl: string | undefined;
let generation = 0;

export function isPublicReplayPage(environment: string, url: URL): boolean {
  return environment === 'production' && url.origin === 'https://userill.dev' && publicPaths.has(url.pathname);
}

export function publicReplayLoaded(): boolean { return recordedUrl !== undefined; }
export function publicReplayNeedsNavigation(): boolean {
  return recordedUrl !== undefined && recordedUrl !== window.location.href;
}

export function stopPublicReplay(): void {
  generation++;
  posthog.stopSessionRecording();
}

// Called only after the public shell has mounted. Never start on an unknown session.
export function startPublicReplay(): () => void {
  const current = ++generation;
  const allowed = () => current === generation
    && isPublicReplayPage(import.meta.env.MODE, new URL(window.location.href))
    && !(navigator as Navigator & { globalPrivacyControl?: boolean }).globalPrivacyControl
    && !posthog.has_opted_out_capturing();
  if (!allowed()) return () => {};
  void fetch('/api/session', { credentials: 'same-origin', cache: 'no-store' }).then((response) => {
    if (response.status !== 401 || !allowed()) return;
    recordedUrl = window.location.href;
    // Keep project sampling and recording rules in effect.
    posthog.startSessionRecording();
    // Surveys remain paused via the default PostHog privacy configuration.
  }).catch(() => { /* Unknown session: keep replay disabled. */ });
  const timer = window.setInterval(() => { if (!allowed()) stopPublicReplay(); }, 1000);
  return () => { window.clearInterval(timer); stopPublicReplay(); };
}
